import * as eventStatus from 'event-widgets/clients/EventStatus';
import { stripQueryParams, addQueryParams } from './queryUtils';
import qs from 'querystring';
import getAllWidgetsOnPage from 'nucleus-widgets/utils/layout/getAllWidgetsOnPage';


// isRegPage added for PROD-73260
export const canModifyRegistration = (event, deadline, isRegPage = false) => {
  const pastDeadline = deadline < new Date();
  const isClosed = event.status === eventStatus.CLOSED;
  const isActive = event.status === eventStatus.ACTIVE;
  const isPending = event.status === eventStatus.PENDING;
  const isInTestMode = event.isInTestMode;
  return (isActive || isClosed || (isPending && isInTestMode)) && (isRegPage ? true : !pastDeadline);
};

export const getCurrentEventRegistrationIdFromURL = (url) => {
  const query = qs.parse(url.split('?')[1]) || {};
  return query && {
    currentEventRegistrationId: query.cer,
    memberCompletedReg: query.mcr
  };
};

export function containsRegistrationSummary(website, pageId) {
  let hasRegSum = false;
  getAllWidgetsOnPage(website, pageId).forEach(object => {
    if (object.widgetType === 'RegistrationSummary') {
      hasRegSum = true;
    }
  });
  return hasRegSum;
}

export const urlStrippedCurrentEventRegistrationId = (url) => {
  return stripQueryParams(url, ['cer', 'mcr']);
};

export const urlStrippedRetryAttempt = (url) => {
  return stripQueryParams(url, ['retryAttempt']);
};

export const addRetryAttempt = (url) => {
  return addQueryParams(url, { retryAttempt: 'true' });
};

export function addGroupMemberEventRegIdToUrl(url, eventRegId,
  memberCompletedReg = false) {
  const params = { cer: eventRegId, mcr: memberCompletedReg };
  return addQueryParams(urlStrippedCurrentEventRegistrationId(url), params);
}
